/* global QuantumMetricAPI */
declare global {
  const QuantumMetricAPI: any;
}

export const getQmReplayLink = () => {
  try {
    if (
      typeof QuantumMetricAPI !== 'undefined' &&
      !!QuantumMetricAPI.getReplay
    ) {
      return QuantumMetricAPI.getReplay();
    }
  } catch {
    // Don't let QM rain on our parade
  }
};
